import React from 'react';
import { WizardStage } from '../../types/profile';

interface WizardProgressBarProps {
  stages: WizardStage[];
  currentStage: number;
  currentStep: number;
  completionPercentage: number;
}

const WizardProgressBar: React.FC<WizardProgressBarProps> = ({
  stages,
  currentStage,
  currentStep,
  completionPercentage,
}) => {
  return (
    <div className="wizard-progress">
      <div className="wizard-progress-bar">
        <div
          className="wizard-progress-fill"
          style={{ width: `${completionPercentage}%` }}
        />
      </div>

      <div className="wizard-progress-stages">
        {stages.map((stage, index) => {
          const stageNumber = index + 1;
          const isCompleted = stageNumber < currentStage;
          const isCurrent = stageNumber === currentStage;
          const isUpcoming = stageNumber > currentStage;

          return (
            <div
              key={stage.id}
              className={`wizard-progress-stage ${
                isCompleted ? 'completed' : ''
              } ${isCurrent ? 'current' : ''} ${isUpcoming ? 'upcoming' : ''}`}
            >
              <div className="wizard-progress-stage-indicator">
                {isCompleted ? (
                  <svg
                    className="wizard-check-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  <span>{stageNumber}</span>
                )}
              </div>

              <div className="wizard-progress-stage-info">
                <span className="wizard-progress-stage-title">{stage.title}</span>
                {isCurrent && stage.steps.length > 1 && (
                  <span className="wizard-progress-step-indicator">
                    Step {currentStep} of {stage.steps.length}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="wizard-progress-percentage">
        {completionPercentage}% Complete
      </div>
    </div>
  );
};

export default WizardProgressBar;
